export const version = "14.7.39";
//# sourceMappingURL=version.js.map